import { Divider, Form, Input, InputNumber, Radio, Select, Space } from "antd";
import { useWatch } from "antd/es/form/Form";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveFile } from "../../../../features/save/saveSlice";
import { formatPath, formatText } from "../../../../utils";
import uplooadSimple from "../../../../assets/UploadSimple.svg";
import { mtrTypeData } from "../../../../data";
import toast from "react-hot-toast";

function Water({ form, fileUrl, setfileUrl }) {
  const { irrType, wtrSources } = useSelector((state) => state.fetch);
  const { activeObjSchemes, wtrAbstraction, wtrConvMeans, wtrAppl } =
    useSelector((state) => ({
      activeObjSchemes: state.obj.activeObj["asalSchemes"],
      wtrAbstraction: state.fetch.wtrAbstraction,
      wtrConvMeans: state.fetch.wtrConvMeans,
      wtrAppl: state.fetch.wtrAppl,
    }));
  const plainOptions = ["Yes", "No"];

  const waterStorageAvailable = useWatch("schIsWaterStorageAvailable", form);
  const wtrAbstOther = useWatch("schWaterAbstractionMode", form);
  const wtrConvOther = useWatch("schWaterConveyingMeans", form);
  const schAbsPermit = useWatch("schAbsPermit", form);
  const schWaterMeters = useWatch("schWaterMeters", form);

  const dispatch = useDispatch();
  async function handleUpload(e) {
    const formObject = new FormData();
    formObject.append("file", e.target.files[0]);
    const file = e.target.files[0];
    if (file) {
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("File size exceeds 10MB. Please upload a smaller file.");
        return;
      }
      const res = await dispatch(saveFile(formObject));

      if (res?.payload?.success) {
        await setfileUrl(res.payload?.targetUrl);
        await toast.success(res?.payload?.message);
      } else {
        toast.error(res?.payload?.message);
      }
    }
  }

  async function handleOpenFIle() {
    document.getElementById("file").click();
  }
  async function handleCancelFile() {
    await setfileUrl();
  }
  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
      <Form.Item
        label={"Irrigation Type"}
        name="schIrrigationTypeId"
        rules={[
          {
            required: true,
            message: "Please select Irrigation Type",
          },
        ]}
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          dropdownRender={(menu) => (
            <>
              <Space style={{ padding: "8px 8px 4px" }}>
                <span className="select-info mt-1">
                  Choose one or more of the following irrigation types
                </span>
              </Space>
              <Divider style={{ margin: "8px 0" }} />
              {menu}
            </>
          )}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children?.toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
        >
          {irrType?.length > 0 &&
            irrType?.map((item) => (
              <Select.Option
                key={item?.irrigationTypeId}
                value={item?.irrigationTypeId}
              >
                {item?.irrigationTypeName}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="schWaterSource"
        className=""
        label={"Source of water"}
        rules={[
          {
            required: true,
            message: "Please select Source of water",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            wtrSources?.length > 0 &&
            wtrSources?.map((item) => ({
              value: item?.wtrSource,
              label: item?.wtrSource,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>
      <Form.Item
        name="schDesignCapacity"
        label={"Design Capacity (M3/s)"}
        rules={[
          {
            required: true,
            message: "Please add design capacity",
          },
        ]}
      >
        <InputNumber
          suffix={
            <span>
              M<sup>3</sup>
            </span>
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>

      <Form.Item
        name="schIsWaterAdequate"
        className=""
        label={"Water is Adequate ?"}
        rules={[
          {
            required: true,
            message: "Please select  water is adequate",
          },
        ]}
      >
        <Radio.Group options={plainOptions} />
      </Form.Item>

      <Form.Item
        name="schAbsPermit"
        className=""
        label={"Do you have Water Abstraction Permit ?"}
        rules={[
          {
            required: true,
            message: "Please select Water Abstraction Permit",
          },
        ]}
      >
        <Radio.Group options={plainOptions} />
      </Form.Item>
      {schAbsPermit === "Yes" ? (
        <Form.Item
          extra={"File should be in Pdf format"}
          rules={[
            {
              required: schAbsPermit === "Yes" ? true : false,
              message: "Upload file .pdf",
            },
          ]}
          name={"schPermitFile"}
          label={<span className="">Abstraction Permit</span>}
        >
          {fileUrl ? (
            <>
              <div className="text-blueDark w-full flex justify-between items-center h-auto px-3 input truncate">
                <span className="text-[18px]">{formatPath(fileUrl)}</span>

                <button
                  type="button"
                  onClick={handleCancelFile}
                  className="flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M9.5 13H15.5C15.7652 13 16.0196 12.8946 16.2071 12.7071C16.3946 12.5196 16.5 12.2652 16.5 12C16.5 11.7348 16.3946 11.4804 16.2071 11.2929C16.0196 11.1054 15.7652 11 15.5 11H9.5C9.23478 11 8.98043 11.1054 8.79289 11.2929C8.60536 11.4804 8.5 11.7348 8.5 12C8.5 12.2652 8.60536 12.5196 8.79289 12.7071C8.98043 12.8946 9.23478 13 9.5 13ZM21.5 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V21C2.5 21.2652 2.60536 21.5196 2.79289 21.7071C2.98043 21.8946 3.23478 22 3.5 22H21.5C21.7652 22 22.0196 21.8946 22.2071 21.7071C22.3946 21.5196 22.5 21.2652 22.5 21V3C22.5 2.73478 22.3946 2.48043 22.2071 2.29289C22.0196 2.10536 21.7652 2 21.5 2ZM20.5 20H4.5V4H20.5V20Z"
                      fill="#147CBC"
                    />
                  </svg>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="input relative" onClick={handleOpenFIle}>
                <input
                  className="!hidden"
                  accept=".pdf"
                  id="file"
                  name="file"
                  onChange={(e) => handleUpload(e)}
                  type="file"
                />
                <div className="absolute inset-0 flex items-center justify-end pointer-events-none px-3">
                  <img src={uplooadSimple} alt="uploadSimple" />
                </div>
              </div>
            </>
          )}
        </Form.Item>
      ) : null}
      <Form.Item
        name="schWaterMeters"
        className=""
        label={"Do you Have Water Meters ?"}
        rules={[
          {
            required: true,
            message: "Please select Water meters",
          },
        ]}
      >
        <Radio.Group options={plainOptions} />
      </Form.Item>
      {schWaterMeters === "Yes" && (
        <Form.Item
          name="schWaterMeterType"
          className=""
          label={"Water Meter Type"}
          rules={[
            {
              required: true,
              message: "Please select water meter type",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              mtrTypeData?.length > 0 &&
              mtrTypeData?.map((item) => ({
                value: item?.value,
                label: formatText(item?.label),
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
      )}

      <Form.Item
        name="schIsWaterStorageAvailable"
        className=""
        label={"Water Storage Available ?"}
        rules={[
          {
            required: true,
            message: "Please select Water storage availability",
          },
        ]}
      >
        <Radio.Group options={plainOptions} />
      </Form.Item>
      {waterStorageAvailable === "Yes" ? (
        <Form.Item
          name="schWaterStorageCapacity"
          label={"Water Storage Capacity (M3/s)"}
          rules={[
            {
              required: true,
              message: "Please add water storage capacity",
            },
          ]}
        >
          <InputNumber
            suffix={
              <span>
                M<sup>3</sup>
              </span>
            }
            min={0}
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            className="input flex"
          />
        </Form.Item>
      ) : null}
      <Form.Item
        name="schWaterAbstractionMode"
        className=""
        label={"Mode of water Abstraction"}
        rules={[
          {
            required: true,
            message: "Please select Mode of water Abstraction",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            wtrAbstraction?.length > 0 &&
            wtrAbstraction?.map((item) => ({
              value: item?.waId,
              label: item?.waType,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>
      {wtrAbstOther === "Other" && (
        <Form.Item
          name="schOtherAbstractionModes"
          className=""
          label={"Other Modes of abstaction"}
          rules={[
            {
              required: false,
              message: "Please select Other Modes of abstaction",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
      )}

      <Form.Item
        name="schWaterConveyingMeans"
        className=""
        label={"Means of Conveying water"}
        rules={[
          {
            required: true,
            message: "Please select Means of Conveying water",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            wtrConvMeans?.length > 0 &&
            wtrConvMeans?.map((item) => ({
              value: item?.wcmId,
              label: item?.wcmType,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>
      {wtrConvOther === "Other" && (
        <Form.Item
          name="schOtherConveyingMeans"
          className=""
          label={"Other means of conveying water"}
          rules={[
            {
              required: false,
              message: "Please select Other means of conveying water",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
      )}

      <Form.Item
        label={"Modes of water Application"}
        name="schWaterApplicationModesId"
        rules={[
          {
            required: true,
            message: "Please select Modes of water application",
          },
        ]}
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          dropdownRender={(menu) => (
            <>
              <Space style={{ padding: "8px 8px 4px" }}>
                <span className="select-info mt-1">
                  Choose one or more of the following water applications
                </span>
              </Space>
              <Divider style={{ margin: "8px 0" }} />
              {menu}
            </>
          )}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children?.toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
        >
          {wtrAppl?.length > 0 &&
            wtrAppl?.map((item) => (
              <Select.Option key={item?.wcmId} value={item?.wcmId}>
                {item?.wamType}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
    </div>
  );
}

export default Water;
